import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CardMedia,
  makeStyles,
  Avatar,
  Divider,
  Box,
  useTheme,
  useMediaQuery,
  Typography,
  CircularProgress,
  Collapse,
} from '@material-ui/core';
import { Link } from 'gatsby-theme-material-ui';
import {
  Dashboard,
  CardGiftcard,
  PowerSettingsNew,
  Store,
  CreditCard,
  Loyalty,
  Business,
  ConfirmationNumber,
  Email,
  Description,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { auth, giftCard, merchant } from '../../../state';
import logoPath from '../../../images/logo.png';
import getCurrentRoute from '../../../utils/getCurrentRoute';
import Coupon from '../../../images/Memberships/coupon.png';
import GroupChatIcon from '../../../images/Memberships/group-chat.png';
import loyaltyApi from '../../../state/loyalty/api';

// const StyledBadge = withStyles((theme) => ({
//   anchorOriginTopRightRectangle: {
//     right: '-20px',
//     top: '6px',
//     fontSize: '8px',
//     color: theme.palette.text.secondary,
//   },
// }))(Badge);

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    width: '285px',
    padding: theme.spacing(0, 1),
    // // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
}));

const SidebarMenu = ({ imageUrl, name }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentRoute = getCurrentRoute(location.pathname);
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));
  const giftCardConfig = useSelector(giftCard.selectors.selectGiftCardConfig);
  // const allLoyaltyPrograms = useSelector(
  //   loyalty.selectors.selectLoyaltyProgram
  // );
  const [activeLoyaltyProgramsCount, setActiveLoyaltyProgramsCount] = useState(
    0
  );
  const getLoyaltyProgramCount = async () => {
    const res = await loyaltyApi.getProgramList({ limit: 1000 });
    const activeProgramsCount = res?.data?.filter(
      (program) => program.status === 1
    ).length;
    setActiveLoyaltyProgramsCount(activeProgramsCount);
  };
  React.useEffect(() => {
    getLoyaltyProgramCount();
  }, []);
  const isLoading = useSelector((state) =>
    auth.selectors.selectIsLoading(state)
  );
  const { enableLoyaltyCard, enableEmailTemplate } = useSelector(
    merchant.selectors.selectMerchantDetails
  );

  const handleLogout = async () => {
    await dispatch(auth.actions.logout());
    navigate('/dashboard/login');
  };

  const [openedMenu, setMenuOpen] = useState();

  const toggleMenu = (menu) => {
    setMenuOpen(openedMenu === menu ? '' : menu);
  };

  useEffect(() => {
    if (giftCardConfig.isEnterprise) {
      console.log('Enterprise', giftCardConfig);
    }
  }, [giftCardConfig]);
  const isShopify = useSelector(merchant.selectors.isShopify);

  return (
    <>
      <div className={classes.toolbar}>
        {sm ? (
          <Box width="100%" align="middle">
            <Link to="/dashboard">
              <CardMedia
                src={logoPath}
                component="img"
                alt="Pintuna logo"
                style={{ width: '120px' }}
              />
            </Link>
          </Box>
        ) : (
          <>
            <Avatar alt={name} src={imageUrl} />
            <Box pl={2}>
              <Typography>{name}</Typography>
            </Box>
          </>
        )}
      </div>
      {sm ? <Divider /> : null}
      <List>
        <Link to="/dashboard/statistics" underline="none">
          <ListItem button selected={location.pathname.includes('statistics')}>
            <ListItemIcon>
              <Dashboard />
            </ListItemIcon>
            <ListItemText primary={t('dashboard')} />
          </ListItem>
        </Link>
        <Link to="/dashboard/business-profile" underline="none">
          <ListItem button selected={currentRoute === 'business-profile'}>
            <ListItemIcon>
              <Store />
            </ListItemIcon>
            <ListItemText primary={t('businessProfile')} />
          </ListItem>
        </Link>
        <ListItem>
          <ListItemIcon />
          <Box mt={1}>
            <h3>{t('apps')}</h3>
          </Box>
        </ListItem>
        <Link to="/dashboard/gift-cards" underline="none">
          <ListItem button selected={currentRoute.includes('gift-cards')}>
            <ListItemIcon>
              <CardGiftcard />
            </ListItemIcon>
            <ListItemText primary={t('giftCardService')} />
          </ListItem>
        </Link>
        {giftCardConfig.isEnterprise && (
          <Collapse
            in={giftCardConfig.isEnterprise}
            component="li"
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding className={classes.nested}>
              <Link
                to={`/dashboard/gift-cards/enterprises/${giftCardConfig.id}`}
                underline="none"
              >
                <ListItem button selected={currentRoute === 'enterprises'}>
                  <ListItemIcon>
                    <Business />
                  </ListItemIcon>
                  <ListItemText primary={t('enterpriseCustomers')} />
                </ListItem>
              </Link>
            </List>
            <Divider />
          </Collapse>
        )}
        <Link to="/dashboard/store-credits" underline="none">
          <ListItem button selected={currentRoute === 'store-credits'}>
            <ListItemIcon>
              <CreditCard />
            </ListItemIcon>
            <ListItemText primary={t('storeCredit.storeCredits')} />
          </ListItem>
        </Link>
        {!isShopify && (
          <Link to="/dashboard/memberships" underline="none">
            <ListItem button selected={currentRoute === 'memberships'}>
              <ListItemIcon>
                <img
                  src={GroupChatIcon}
                  alt={t('membership.memberships')}
                  style={{ width: 23 }}
                />
              </ListItemIcon>
              <ListItemText primary={t('membership.memberships')} />
            </ListItem>
          </Link>
        )}

        {enableLoyaltyCard ? (
          <>
            <ListItem
              button
              onClick={() => toggleMenu('loyalty')}
              selected={currentRoute === 'loyalty' || currentRoute === 'manage'}
            >
              <ListItemIcon>
                <Loyalty />
              </ListItemIcon>
              <ListItemText primary={t('loyalty.loyalty')} />
            </ListItem>
            <Collapse
              component="li"
              timeout="auto"
              unmountOnExit
              in={openedMenu === 'loyalty'}
            >
              <List>
                <Link to="/dashboard/loyalty" underline="none">
                  <ListItem button selected={currentRoute === 'loyalty'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('loyalty.createProgram')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/loyalty/manage" underline="none">
                  <ListItem button selected={currentRoute === 'manage'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('loyalty.manageProgram')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/loyalty/list" underline="none">
                  <ListItem button selected={currentRoute === 'list'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('loyalty.customerList')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                {activeLoyaltyProgramsCount > 1 && (
                  <Link
                    to="/dashboard/loyalty/overarching-program"
                    underline="none"
                  >
                    <ListItem
                      button
                      selected={currentRoute === 'overarching-program'}
                    >
                      <ListItemIcon />
                      <ListItemText
                        primary={t('loyalty.overarching.program')}
                        style={{ paddingLeft: 30 }}
                      />
                    </ListItem>
                  </Link>
                )}
              </List>
            </Collapse>
          </>
        ) : (
          <Link to="/dashboard/loyalty" underline="none">
            <ListItem button selected={currentRoute === 'loyalty'}>
              <ListItemIcon>
                <Loyalty />
              </ListItemIcon>
              <ListItemText primary={t('loyalty.loyalty')} />
            </ListItem>
          </Link>
        )}
        {!isShopify && (
          <>
            <ListItem
              button
              selected={currentRoute.includes('tickets')}
              onClick={() => toggleMenu('tickets')}
            >
              <ListItemIcon>
                <ConfirmationNumber />
              </ListItemIcon>
              <ListItemText primary={t('tickets.ticketing')} />
            </ListItem>
            <Collapse
              component="li"
              timeout="auto"
              unmountOnExit
              in={openedMenu === 'tickets'}
            >
              <List>
                <Link to="/dashboard/ticketing/events/create" underline="none">
                  <ListItem
                    button
                    selected={location.pathname.includes(
                      'ticketing/events/create'
                    )}
                  >
                    <ListItemIcon />
                    <ListItemText
                      primary={t('tickets.createEvents')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/ticketing/events" underline="none">
                  <ListItem button selected={currentRoute === 'events'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('tickets.manageEvents')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/ticketing/insights" underline="none">
                  <ListItem button selected={currentRoute === 'insights'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('tickets.insights.menuLabel')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/ticketing/tickets" underline="none">
                  <ListItem button selected={currentRoute === 'tickets'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('tickets.tickets')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/ticketing/orders" underline="none">
                  <ListItem button selected={currentRoute === 'orders'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('tickets.orders')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/ticketing/setup" underline="none">
                  <ListItem button selected={currentRoute === 'setup'}>
                    <ListItemIcon />
                    <ListItemText
                      primary={t('tickets.setup')}
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
              </List>
            </Collapse>
          </>
        )}
        <Link to="/dashboard/coupons" underline="none">
          <ListItem button selected={currentRoute === 'coupons'}>
            <ListItemIcon>
              <img
                src={Coupon}
                alt={t('membership.membershipList.couponList')}
                style={{ width: 20 }}
              />
            </ListItemIcon>

            <ListItemText primary={t('coupons.coupons')} />
          </ListItem>
        </Link>
        {!isShopify && (
          <>
            <ListItem
              button
              selected={currentRoute.includes('waivers')}
              onClick={() => toggleMenu('waivers')}
            >
              <ListItemIcon>
                <Description />
              </ListItemIcon>
              <ListItemText primary="Waivers" />
            </ListItem>
            <Collapse
              component="li"
              timeout="auto"
              unmountOnExit
              in={openedMenu === 'waivers'}
            >
              <List>
                <Link to="/dashboard/waivers/create" underline="none">
                  <ListItem
                    button
                    selected={location.pathname.includes('waivers/create')}
                  >
                    <ListItemIcon />
                    <ListItemText
                      primary="Create Template"
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/waivers/manage" underline="none">
                  <ListItem
                    button
                    selected={location.pathname.includes('waivers/manage')}
                  >
                    <ListItemIcon />
                    <ListItemText
                      primary="Manage Templates"
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
                <Link to="/dashboard/waivers/signed" underline="none">
                  <ListItem
                    button
                    selected={location.pathname.includes('waivers/signed')}
                  >
                    <ListItemIcon />
                    <ListItemText
                      primary="Signed Waivers"
                      style={{ paddingLeft: 30 }}
                    />
                  </ListItem>
                </Link>
              </List>
            </Collapse>
          </>
        )}
        {enableEmailTemplate && (
          <>
            <Box mt={2} mb={2} pl={2} pr={2}>
              <Divider />
            </Box>
            <Link to="/dashboard/email-templates" underline="none">
              <ListItem button selected={currentRoute === 'email-templates'}>
                <ListItemIcon>
                  <Email />
                </ListItemIcon>
                <ListItemText
                  primary={t('emailTemplates.manageEmailTemplates')}
                />
              </ListItem>
            </Link>
          </>
        )}
        {!sm ? (
          <>
            <Divider />
            <Link to="/dashboard/business-profile" underline="none">
              <ListItem button selected={currentRoute === 'business-profile'}>
                <ListItemIcon>
                  <Store />
                </ListItemIcon>
                <ListItemText primary={t('businessProfile')} />
              </ListItem>
            </Link>
            <ListItem button onClick={handleLogout}>
              <ListItemIcon>
                {isLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  <PowerSettingsNew />
                )}
              </ListItemIcon>
              <ListItemText primary={t('logout')} />
            </ListItem>
          </>
        ) : null}
      </List>
    </>
  );
};

SidebarMenu.defaultProps = {
  name: '',
  imageUrl: '',
};

SidebarMenu.propTypes = {
  name: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default SidebarMenu;
